import React from 'react';
export default {
  'cart': {
    'change-currency': 'Изменить валюту',
    'and-then': 'А затем',
    'plus-tax': ' + налог',
    'for': 'Для',
    'edit': {
      'label': 'Редактировать',
      'submit': 'Применить'
    },
    'empty': 'Вы еще ничего не добавили в свой заказ.',
    'free': 'бесплатно',
    'promo-code': {
      'add': 'Добавить подарочную карту или промокод',
      'error': {
        'invalid-for-subscription': 'Промокод недействителен для этого заказа.'
      },
      'label': 'Подарочная карта или промокод',
      'submit': 'Применить'
    },
    'subtotal-line': {
      'tax-label': 'Приблизительный налог',
      'subtotal': 'Подытог',
      'tax': 'Налог',
      'gift-card': 'подарочная карта'
    },
    'starting-price': 'Начальная цена',
    'title': 'Заказать Основная',
    'setup-fee': 'стоимость настройки',
    'free-trial': 'бесплатная пробная версия',
    'total-line': {
      'label': 'Всего'
    },
    'order-total-line': {
      'label': 'Общая сумма заказа'
    }
  },
  'address': {
    'country': 'Страна',
    'address2': 'Квартира, номер, и т.д.',
    'tax-identifier': 'Налоговый идентификатор',
    'tax-identifier-type': 'Тип налогового идентификатора',
    'first-name': 'Имя',
    'last-name': 'Фамилия',
    'company-name': 'название компании',
    'address1': 'Адрес улица',
    'city': 'Город',
    'state': 'Провинция',
    'postal-code': 'Почтовый индекс',
    'phone-number': 'Номер телефона',
    'vat-number': 'НДС номер/Налоговый ID'
  },
  'payment-method': {
    'credit-card': {
      'label': 'Реквизиты карты',
      'expiry': 'ММ/ГГ',
      'name': 'кредитная карта',
      'number': 'Номер кредитной карты',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'Банковский счет',
      'routing-number': 'Kод банка',
      'account-number': 'Номер Счета',
      'account-number-confirmation': 'Подтвердите номер счета',
      'account-type': {
        'label': 'Тип Счета',
        'checking': 'Tекущий банковский счет',
        'savings': 'Сберегательный счет'
      },
      'name-on-account': 'Имя Счета'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort код'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB код'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'Платежный адрес',
  'billing-address-same-as-shipping': 'Тот же, что и адрес доставки',
  'submit': 'Оплатить сейчас',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} выбрано</>,
  'express-checkout': 'Экспресс-оформление заказа',
  'change-payment-method': 'Изменить способ оплаты',
  'day': 'день',
  'days': 'дни',
  'week': 'неделя',
  'weeks': 'недели',
  'month': 'месяц',
  'months': 'месяцы',
  'year': 'годы',
  'years': 'годы',
  'confirmation': {
    'title': 'Спасибо за ваш заказ',
    'order-num': ({ number }: { number: number }) => <>Заказ №{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>Размещен {date}</>,
    'email-notice': 'Вы получите электронное письмо с подтверждением вашего заказа.',
    'payment': 'Оплата',
    'return-to': ({ name }: { name: string }) => <>Вернуться к {name}</>,
    'credit-applied': 'кредит применен'
  },
  'back': 'Назад',
  'contact-info': 'Контактная информация',
  'email-address': 'Эл. адрес',
  'payment-info': 'Платежная информация',
  'shipping-address': 'Адрес доставки',
  'legal': {
    'accept': 'Я принимаю',
    'privacy-policy': 'Политика конфиденциальности ',
    'terms-of-service': 'Условия предоставления услуг'
  },
  'recurring': {
    'consent': `Я согласен(-на) оплачивать вышеуказанные расходы с указанной периодичностью выставления счетов,
                на регулярной основе, если только подписка не будет отменена до окончания текущего расчетного периода.`,
    'cancel': 'Чтобы отменить подписку, посетите страницу управления аккаунтом.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => {
      if (count === 1) return 'день';
      if (count >= 2 && count <= 4) return 'дня';
      return 'дней';
    },
    'weeks': ({ count }: { count: number }) => {
      if (count === 1) return 'неделя';
      if (count >= 2 && count <= 4) return 'недели';
      return 'недель';
    },
    'months': ({ count }: { count: number }) => {
      if (count === 1) return 'месяц';
      if (count >= 2 && count <= 4) return 'месяца';
      return 'месяцев';
    },
    'years': ({ count }: { count: number }) => {
      if (count === 1) return 'год';
      if (count >= 2 && count <= 4) return 'года';
      return 'лет';
    }
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>С вас будет взиматься плата {amount}/единица за {addOnName}</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>С вас будет взиматься плата {amount} за {units} {unitsLabel} из {addOnName}</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>Начиная с {startDate}, с вас будет взиматься плата {amount}/{intervalLengthLabel}{taxable ? ' + налог' : ''}</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>Начиная с {startDate}, с вас будет взиматься плата {amount}/{intervalLengthLabel}{taxable ? ' + налог' : ''}, а также единоразовая плата {setupFee}</>,
      'cancellation.reminder': 'Вы получите напоминание по электронной почте за {days} дней до начала выставления счетов.',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: string; trialInterval: string }) => <>Сегодня начинается ваша бесплатная пробная версия на {trialLength} {trialInterval}.</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>Чтобы избежать платы, вы должны отменить до {trialEndsAt}.</>,
      'email.reminder': ({ days }: { days: number }) => <>Вы получите напоминание по электронной почте за {days} дней до начала выставления счетов.</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>Ваша подписка закончится {billingEndsAt} и не будет автоматически продлена.</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>После {afterChargeTime} с вас будет взиматься плата {newChargeAmount} + налог</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>Ваша подписка будет автоматически продлеваться каждые {totalCyclesLengthLabel} и будет продолжаться до тех пор, пока вы не отмените.</>,
      'title': 'Подробности подписки',
    },
    'agreement.button': 'Принять и Продолжить',
    'agreement.text': 'Нажимая "Принять и Продолжить", вы подтверждаете, что понимаете и принимаете эти условия подписки. Никакие платежи не будут применены до завершения покупки.',
    'changeOrCancel': 'Чтобы изменить или отменить подписку ',
    'access-account': 'войдите в свой аккаунт',
    'contact-support': 'обратитесь в службу поддержки',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' и ',
      'lastWordConnector': ' и '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>Счета за подписку формируются при поддержке  {recurly}</>,
  'errors': {},
  'subscribe': 'Подписаться'
};
